mod.modules.define("DashboardAnalytics", "BaseAnalytics", function(fn) {

	fn.prototype.init = function(params) {
		this.category = "Dashboard";

		// Show that we landed on the page
		//this.trackPage(this.category);
	};

	// Disabling actions for business reasons

	//fn.prototype.observables = {};

});